import TableItemList, { TableItemListProps } from './TableItemList';

export type { TableItemListProps };
export default TableItemList;
